import styled from 'styled-components';

const BlockQuote = styled.blockquote`
    border-color: #66bb6a;
    font-style: italic;

    p:not(:last-child) {
        padding-bottom: 20px;
    }
`;

export default BlockQuote;
